import { css } from '@emotion/css';
import { ActionIcon, Button, colorsTuple, Container, createTheme, Indicator } from '@mantine/core';
import { type PartialTableTheme } from 'schummar-table';

export const theme = createTheme({
    black: '#333',

    colors: {
        primary: colorsTuple([
            '#e7f9fd',
            '#ddecef',
            '#c0d5da',
            '#9fbdc4',
            '#84a8b1',
            '#729ca6',
            '#62929e',
            '#55828d',
            '#47747f',
            '#326570',
        ]),
        secondary: colorsTuple([
            '#fff9e1',
            '#fdf2cd',
            '#f9e39f',
            '#f5d46d',
            '#f2c94c',
            '#efbe28',
            '#efba16',
            '#d4a305',
            '#bd9100',
            '#a37c00',
        ]),
    },

    autoContrast: true,
    primaryColor: 'primary',

    fontFamily: 'Open Sans, sans-serif',
    headings: {
        fontFamily: 'Open Sans, sans-serif',
        sizes: {
            h1: { fontSize: '1.5rem', fontWeight: 'bold' },
            h2: { fontSize: '1.2rem', fontWeight: 'bold' },
            h3: { fontSize: '1.2rem', fontWeight: 'normal' },
            h4: { fontSize: '1.0rem', fontWeight: 'normal' },
        },
    },

    components: {
        Indicator: Indicator.extend({
            defaultProps: {
                zIndex: 10,
            },
        }),

        ActionIcon: ActionIcon.extend({
            defaultProps: {
                variant: 'transparent',
            },
            styles(_theme, props) {
                if (props.variant === 'transparent' && !props.color) {
                    return {
                        root: {
                            color: 'inherit',

                            '@media (hover: hover)': {
                                '&:hover:where(:not([data-loading], :disabled, [data-disabled]))': {
                                    color: 'inherit',
                                },
                            },
                        },
                    };
                }

                return {};
            },
        }),

        Button: Button.extend({
            classNames(_theme, props) {
                return {
                    root: css([
                        {
                            fontWeight: 500,
                        },
                        props.variant === 'transparent' &&
                            !props.color && {
                                color: 'inherit',
                            },
                        props.variant === 'outline' &&
                            !props.color && {
                                color: 'inherit',
                                borderColor: 'currentColor',
                            },
                    ]),
                };
            },
        }),

        Container: Container.extend({
            defaultProps: {
                strategy: 'grid',
            },
        }),
    },
});

export const tableTheme: PartialTableTheme = {
    colors: {
        primary: { main: '#62929E', light: '#62929E', contrastText: 'white' },
        secondary: { main: '#F2C94C', light: '#F2C94C', contrastText: '#333' },
    },
};
